export const SECTION_IDS = {
  proceso: 'proceso',
  servicios: 'servicios',
  testimonios: 'testimonios',
  preguntas: 'preguntas',
  formulario: 'formulario',
} as const

export type SectionId = (typeof SECTION_IDS)[keyof typeof SECTION_IDS]

export function scrollToSection(id: SectionId): void {
  const el = document.getElementById(id)
  if (!el) return
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  el.scrollIntoView({
    behavior: prefersReduced ? 'auto' : 'smooth',
    block: 'start',
  })
}
